// AMO & CO. — Main JavaScript

// Header scroll effect
(function() {
  var header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 50);
    });
  }
})();

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(function(a) {
  a.addEventListener('click', function(e) {
    var target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// Desktop country dropdown toggle + positioning
(function() {
  var btn = document.getElementById('country-btn');
  var dropdown = document.getElementById('country-dropdown');
  if (!btn || !dropdown) return;

  var search = dropdown.querySelector('.header__country-search');

  function closeDropdown() {
    dropdown.classList.remove('open');
    if (search) {
      search.value = '';
      dropdown.querySelectorAll('.header__country-option').forEach(function(opt) {
        opt.style.display = '';
      });
    }
  }

  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    var wasOpen = dropdown.classList.contains('open');
    if (wasOpen) {
      closeDropdown();
    } else {
      // Position dropdown below the nav pill, aligned right with button
      var btnRect = btn.getBoundingClientRect();
      var innerRect = document.querySelector('.header__inner').getBoundingClientRect();
      dropdown.style.position = 'fixed';
      dropdown.style.top = (innerRect.bottom + 8) + 'px';
      dropdown.style.right = (window.innerWidth - btnRect.right) + 'px';
      dropdown.classList.add('open');
      if (search) search.focus();
    }
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.header__country-dropdown') && !e.target.closest('#country-btn')) {
      closeDropdown();
    }
  });

  if (search) {
    search.addEventListener('keyup', function() {
      var query = search.value.toLowerCase();
      dropdown.querySelectorAll('.header__country-option').forEach(function(opt) {
        opt.style.display = opt.textContent.toLowerCase().indexOf(query) > -1 ? '' : 'none';
      });
    });
  }
})();

// Mobile hamburger menu with sliding country panel
(function() {
  var hamburger = document.querySelector('.hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  var countryTrigger = document.getElementById('mobile-country-trigger');
  var countryBack = document.getElementById('mobile-country-back');
  var mobileSearch = mobileNav ? mobileNav.querySelector('.mobile-nav__search') : null;

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function() {
      var isOpen = mobileNav.classList.toggle('open');
      hamburger.classList.toggle('open');
      if (!isOpen) {
        mobileNav.classList.remove('show-countries');
        if (mobileSearch) {
          mobileSearch.value = '';
          mobileNav.querySelectorAll('.mobile-nav__country-option').forEach(function(opt) {
            opt.style.display = '';
          });
        }
      }
    });
  }

  if (countryTrigger && mobileNav) {
    countryTrigger.addEventListener('click', function() {
      mobileNav.classList.add('show-countries');
      if (mobileSearch) setTimeout(function() { mobileSearch.focus(); }, 350);
    });
  }

  if (countryBack && mobileNav) {
    countryBack.addEventListener('click', function() {
      mobileNav.classList.remove('show-countries');
      if (mobileSearch) {
        mobileSearch.value = '';
        mobileNav.querySelectorAll('.mobile-nav__country-option').forEach(function(opt) {
          opt.style.display = '';
        });
      }
    });
  }

  if (mobileSearch) {
    mobileSearch.addEventListener('keyup', function() {
      var query = mobileSearch.value.toLowerCase();
      mobileNav.querySelectorAll('.mobile-nav__country-option').forEach(function(opt) {
        opt.style.display = opt.textContent.toLowerCase().indexOf(query) > -1 ? '' : 'none';
      });
    });
  }
})();
